import React, { useState } from 'react';
import { Box, Typography, Card, Divider } from '@mui/material';
import { DashboardWrapper, TopupButton } from './TopUpStyle';
import TopIcon from '../../assets/TopupIcon.svg';
import noTransIcon from '../../assets/noTrans.svg';
import { VscEye, VscEyeClosed } from 'react-icons/vsc';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import CurrencyExchangeSharpIcon from '@mui/icons-material/CurrencyExchangeSharp';
import PreferenceLink from '../../components/preferenceLink/PreferenceLink';
import LastTransaction from '../../components/lastTransaction/LastTransaction';
import TopUpForm from '../../components/forms/topUpForm/topUpForm';
import { useNavigate } from 'react-router-dom';
import {
   getAuthSelector,
   getTransactions,
} from '../../components/utils/selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import TransactionLoading from '../../components/mui_skeleton/LastTransactionSkeleton';
import { getLastFour } from '../../components/app/features/transactions/TransactionSlice';
import { getUserProfile } from '../../components/app/features/auth/AuthSlice';
import { userLSAuth } from '../../components/app/features/env';
import { Container } from '../firstPage/style';

const TopUp = () => {
   const [isShowPwd, setIsShowPwd] = useState(true);
   const [open, setOpen] = useState(false);
   const [balance, setBalance] = React.useState(userLSAuth()?.balance);

   const dispatch = useDispatch();
   const navigate = useNavigate();
   const authselector = useSelector(getAuthSelector);
   const selector = useSelector(getTransactions);

   const currentDate = new Date();
   const today = `${
      currentDate.getMonth() + 1
   }/${currentDate.getDate()}/${currentDate.getFullYear()}`;

   const oneYearAgo = new Date(
      currentDate.getFullYear() - 1,
      currentDate.getMonth(),
      currentDate.getDate()
   );

   const lastYearString = oneYearAgo.toISOString();

   const time = {
      start: lastYearString,
      end: new Date().toISOString(),
   };

   React.useEffect(() => {
      dispatch(getUserProfile());

      dispatch(
         getLastFour({
            userId: userLSAuth()?.id,
            timeFrame: time,
            page: 1,
         })
      );
   }, []);

   React.useEffect(() => {
      if (authselector.updatedProfile !== null) {
         setBalance(
            authselector.updatedProfile.balance !== null
               ? authselector.updatedProfile.balance
               : 0
         );
      }
   }, [authselector.updated === true]);

   const toggleBalance = () => {
      // inverse the boolean state of isShowPwd
      setIsShowPwd(!isShowPwd);
   };

   const handleCloseForm = () => {
      setOpen(false);
   };

   return (
      <Container>
         <Card
            sx={{
               width:{xs:'100%', sm:'90%'} ,
               maxWidth: '615px',
               height: 'fit',
               margin: '0 auto',
               marginTop: '7rem',
               position: 'relative',
               background: 'white',
              borderRadius:'8px'
            }}
         >
            {open && <TopUpForm openForm={open} closeForm={handleCloseForm} />}
            <Box
               sx={{
                  position: 'relative',
               }}
            >
               <Box className="topUpWrapper">
                  <Box className="profileCard" color="white">
                     <Typography
                        className="font-cormorant"
                        sx={{
                           width: '100%',
                           color: '#2E2C21',
                           fontWeight: 600,
                           textAlign: 'center',
                           fontSize: {
                              xs: '1.8rem',
                              sm: '2rem',
                              md: '2.5rem',
                            
                              marginTop: '2rem',
                           },
                        }}
                     >
                        Top-Up
                     </Typography>
                     <Box sx={{margin:{ xs:'0.5rem', sm:'2rem'}, padding:'1rem', background:'#eaf2ff', borderRadius:'16px'}}>
                        <Box
                           display="flex"
                           p={2}
                           textAlign="center"
                           alignItems="center"
                        >
                           <Typography
                              className="font-cormorant"
                              flex={1}
                              sx={{ color: '#2E2C21', fontWeight: '600' }}
                              fontSize={25}
                           >
                              Account Balance
                           </Typography>
                        </Box>
                        <Box
                           display="flex"
                           flexDirection="column"
                           textAlign="center"
                           m="auto"
                        >
                           <Typography
                              sx={{
                                 fontSize: {xs:'1.8rem', sm:'3.9rem'},
                                 fontWeight: 600,
                                 color: '#2e2c21',
                              }}
                           >

                              {isShowPwd
                                 ? balance || userLSAuth().balance
                                 : '*****'}
                           </Typography>
                           <Typography
                              sx={{
                                 fontSize: '1.2rem',
                                 color:'#2E2C21',
                                 fontWeight:'600'
                              }}
                           >
                              SMS Units
                           </Typography>
                           <TopupButton onClick={() => setOpen(true)}>
                     <Box width={25} height={15}>
                      
                     </Box>
                     <Typography
                        ml={1}
                        color="white"
                        fontWeight={500}
                        fontSize={16}
                        sx={{fontSize:{xs:'1rem'}}}
                     >
                        Top-Up
                     </Typography>
                     <img
                           src={TopIcon}
                           alt="TopIcon"
                           style={{ marginLeft: '15px' }}
                        />
                  </TopupButton>
                        </Box>
                        {/* <Box
                           className="passwordIcon"
                           align="right"
                           px={2}
                           fontSize={22}
                        >
                           {isShowPwd ? (
                              <VscEye onClick={toggleBalance} />
                           ) : (
                              <VscEyeClosed onClick={toggleBalance} />
                           )}
                        </Box> */}
                      
                     </Box>
                  </Box>
              

                  {selector.lastFourpaymentData.length > 0 ? (
                     <Typography
                        color="#58564d"
                        fontSize={18}
                        fontWeight={500}
                        mt={6}
                        mb={2}
                        sx={{ color: '#58564d' }}
                     >
                        Last transactions
                     </Typography>
                  ) : selector.lastFourpaymentData.length === 0 &&
                    selector.loading !== 'pending' ? (
                     <Box>
                        <Typography
                           sx={{
                              fontWeight: 600,
                              fontSize: '0.9rem',
                              color: '#0F0E0E',
                              marginTop: '1rem',
                              marginBottom: '1rem',
                              textAlign: 'center',
                           }}
                        >{`Hey ${
                           userLSAuth()?.fullName
                        }  your latest transactions will appear here`}</Typography>
                     </Box>
                  ) : null}

                  {selector.lastFourpaymentData.length > 0 ? (
                     <Box
                        display={'flex'}
                        gap={2}
                        sx={{
                           '@media (max-width: 730px )': {
                              flexWrap: 'wrap',
                           },

                           '@media (max-width: 606px )': {
                              justifyContent: 'center',
                           },
                        }}
                     >
                        {selector.lastFourpaymentData.map((item, index) => (
                           <LastTransaction item={item} key={index} />
                        ))}
                     </Box>
                  ) : selector.loading === 'pending' ? (
                     <Box
                        display={'flex'}
                        gap={2}
                        sx={{
                           flexWrap: 'wrap',
                           justifyContent: 'center',
                           marginTop: '2rem',
                        }}
                     >
                        <TransactionLoading />
                        <TransactionLoading />
                     </Box>
                  ) : null}

<Typography
  sx={{
    color: '#2E2C21',
    fontWeight: 600,
    fontSize: {
      xs: '1.8rem',  
      sm: '2rem',
      md: '2.5rem',
      
    },
    marginLeft:{xs:'1rem' ,sm:'2.6rem' } ,
  }}
  className='font-cormorant'
>
  Preferences
</Typography>

                  <Card
                     sx={{
                        paddingX:{xs:'1rem', sm: '25px'} ,
                        background:'#f9f5de',
                        margin:{xs:'0.5rem', sm:'2rem'},
                        borderRadius:'8px',
                        color:'#2E2C21'
                     }}
                  >
                     <PreferenceLink
                        iconButton={<WorkHistorySharpIcon />}
                        preferenceText="Payment history"
                        handleClick={() => navigate('/top-up/transactions')}
                     />
                     <Divider />
                     <PreferenceLink
                        iconButton={<CurrencyExchangeSharpIcon />}
                        preferenceText="Pricing information"
                        handleClick={() => navigate('/top-up/pricing-info')}
                     />
                  </Card>
               </Box>
            </Box>
         </Card>
      </Container>
   );
};

export default TopUp;
